import axios from '.';
import { type CatchCustomFields, type DebugLevel } from '../../_configs/types';
import { type Car } from '../../_types/Car';

export type SendContactData = {
    dstMail: string;
    xml: boolean;
    catch_values: CatchCustomFields;
    isCatchXML: boolean;
    idCar: Car<false>['id'];
    idKontaktwunsh: number;
    name: string;
    email: string;
    telefon: string;
    msg: string;
    idUser: number;
    subjekt: string;
    termin: string;
    abo?: {
        damage_participation: number;
        delivery_option: ('faaren_delivery' | 'partner_delivery' | 'no_delivery')[];
        delivery_time_after_booking: number;
        duration: number;
        extraMileageCosts: number;
        fixed_duration: boolean;
        immediately_available: boolean;
        mileage: number;
        minimum_age: number;
        min_license_duration: number;
        monthlyRate: number;
        monthlyRateNet: number;
        pick_up_option: ('faaren_delivery' | 'partner_delivery' | 'no_delivery')[];
    };
    leasing?: Car<false>['leasing'] | Car<false>['leasingComm'];
    fin?: Car<false>['finanzierung'];
    customerCreditInfo?: {
        gewerblicheAnfrage: boolean;
        unternehmen_alter: number;
        insolvenzverfahren: boolean;
        unternehmer: boolean;
        fahrzeug_auch_gewerbliche_nutzung: boolean;
        monatliche_ausgaben: number;
        monatliche_einkuenfte: number;
        negativer_schufa_score: boolean;
        personen_in_haushalt: number;
    };
    accessoires?: string;
};

export function sendContact(idFirma: Car<false>['idFirma'], data: SendContactData, debug: DebugLevel) {
    if (!data || !idFirma) return null;

    const url = 'https://cars.autohaus-digital.de/s/v1/sendMail/' + idFirma;
    return axios<string>({
        debug,
        title: 'Senden des Kontaktformulars',
        noLogging: false,
        idFirma,
        method: 'post',
        url: url,
        data: data,
    });
}
